import React from 'react';

import { Grid } from '@material-ui/core';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Footer () {

  const selo = 'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/caminho-seguro/jcs-logo_texto_preto.png';


  return (
    <Grid container style={{paddingTop: 25, paddingBottom: 5, background: "#fafbfc"}}>

    <Grid container item lg={12} sm={12} xs={12} justify="center">
      <Grid  container item lg={1} sm={12} xs={12} style={{paddingLeft: 0}}></Grid>

      <Grid  container item lg={3} sm={12} xs={12} justify="center" style={{paddingTop: 10}} >
        <img src={selo} style={{ width: 200, height: 60}} />
      </Grid>



      <Grid container item lg={3} sm={6} xs={12}  justify="center">
        <p style={{paddingTop: 2}}>
          <p style={{fontSize: 17, color: '#37549a'}}>Central de Relacionamento com o Doador</p>
          <p><WhatsAppIcon style={{ paddingTop: 7, color: '#37549a' }}/><strong style={{fontSize: 16, color: '#37549a',fontWeight: 900}}>(17) 99121-6148</strong></p>

          <p style={{fontSize: 16, color: '#37549a', fontWeight: 900}}>(17) 3044-6461</p>

        </p>
      </Grid>

      <Grid container item lg={3} sm={6} xs={12} justify="center"  >
        <p style={{paddingTop: 3}}>
          <p style={{fontSize: 17, color: '#37549a'}}>Horário de funcionamento</p>
          <p><strong style={{fontSize: 16, color: '#37549a', fontWeight: 900}}>segunda a sexta-feira das</strong></p>
          <p><strong style={{fontSize: 16, color: '#37549a', fontWeight: 900}}>9h às 17h30</strong></p>
        </p>

      </Grid>

      <Grid  container item lg={1} sm={12} xs={12} style={{paddingLeft: 0}}></Grid>

    </Grid>
  </Grid>
  );
}
